export default __webpack_public_path__ + "static/media/kazam-icon.b800376c.png";